const parseBooleanish = (value) => {
  if (value == null || value === '') return null;
  if (value === true || value === 1) return true;
  if (value === false || value === 0) return false;
  const normalized = `${value}`.trim().toLowerCase();
  if (normalized === 'true' || normalized === '1' || normalized === 'yes') return true;
  if (normalized === 'false' || normalized === '0' || normalized === 'no') return false;
  return null;
};

export const toUserIdSet = (conversation) => {
  const participantEntries = Array.isArray(conversation?.participants)
    ? conversation.participants
    : [];
  const userIds = participantEntries
    .map((entry) => entry?.user_id ?? entry?.userId ?? entry?.user?.id ?? entry?.id)
    .filter((value) => value != null);

  return Array.from(new Set(userIds.map((value) => `${value}`)));
};

export const coerceConversationId = (conversationOrId) => {
  if (conversationOrId == null) return null;
  if (typeof conversationOrId === 'object') {
    return (
      conversationOrId.id ??
      conversationOrId.conversation_id ??
      conversationOrId.conversationId ??
      null
    );
  }
  return conversationOrId;
};

export const shouldTreatConversationAsEncrypted = (conversation, messageList = []) => {
  const normalizedEncryptionEnabled =
    parseBooleanish(conversation?.encryptionEnabled) ??
    parseBooleanish(conversation?.encryption_enabled);

  if (normalizedEncryptionEnabled === true) return true;
  if (normalizedEncryptionEnabled === false) {
    return false;
  }
  if (
    conversation &&
    conversation.encryptionEnabled == null &&
    conversation.encryption_enabled == null
  ) {
    return true;
  }
  return (Array.isArray(messageList) ? messageList : []).some(
    (message) => message?.encryptedContent || message?.encrypted_content,
  );
};
